import styled from "styled-components";
import { Button } from "../../styling/card";

export const FormContainer = styled.div`
  display: block;
  padding: 40px;
  box-sizing: border-box;
`;

export const FormGroup = styled.form`
  color: ${(props) => props.theme.color.pink};
  display: block;
  padding: 0 10px;
`;

export const Label = styled.label`
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
  color: ${(props) => props.theme.color.pink};
  display: block;
`;

export const Input = styled.input`
  padding: 8px;
  font-size: 20px;
  font-family: ${(props) => props.theme.font.montserrat};
  border: 1px solid ${(props) => props.theme.color.pink};
  border-radius: 3px;
  width: 100%;
  box-sizing: border-box;
  &::placeholder {
    color: ${(props) => props.theme.color.grey};
  }
`;

export const EmailContainer = styled.div`
  width: 100%;
  display: flex;

  ${Input} {
    width: 50%;
    margin-bottom: 0;
    flex: 1;
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-right: 2px;
  }
`;

export const Email = styled.div`
  display: inline-block;
  font-size: 20px;
  border: 1px solid ${(props) => props.theme.color.pink};
  border-left: 0px;
  background-color: #e2e2e2;
  color: #5a5a5a;
  display: flex;
  align-items: center;
  padding: 0px 12px;
`;

export const ErrorMessage = styled.div`
  margin-top: 10px;
  color: ${(props) => props.theme.color.black};
  font-weight: 500;
`;

export const Border = styled.div`
  background-color: ${(props) => props.theme.color.lightBlue};
  color: ${(props) => props.theme.color.darkBlue};
  padding: 20px;
  border-radius: 20px;
`;

export const BakeTime = styled.div`
  font-size: 34px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const BakeDate = styled.div`
  font-size: 24px;
  margin-bottom: 15px;
`;

export const BakeName = styled.div`
  font-size: 24px;
  font-weight: 500;
`;

export const SubText = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin: 25px 0;
  color: ${(props) => props.theme.color.pink};
`;

export const Text = styled.div`
  font-size: 30px;
  font-weight: 600;
  margin: 0 auto 20px auto;
  color: ${(props) => props.theme.color.pink};
`;

export const SubmitButton = styled(Button)`
  margin-top: 20px;
`;
